import { createTheme } from '@mui/material/styles';
import '@fontsource/montserrat';


export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgba(251,251,251,0)',
      light: 'rgba(80,139,195,0.26)',
      dark: 'rgba(51,92,133,0.47)',

    },
    secondary: {
      main: 'rgba(13, 79, 141, 0.62)',
      light: 'rgba(83,163,234,0.51)',
      dark: 'rgba(4,75,140,0.64)',
    },
    divider: '#ffffff',
    background: {
      default: '#FFFFFF',
      paper: 'rgba(255,255,255,0)',
      gray: '#f9f9f9',
      darkgray: 'rgba(95, 89, 89, 0.47)',
    },
    text: {
      primary: '#2b3a56',
      secondary: 'rgba(255,255,255,0.6)',
      third: 'rgba(70, 94, 118, 0.89)',
      fourth: 'rgb(153, 153, 153)',
      lightGray: '#9a9a9a',
      white: 'rgb(255, 255, 255)',
    },
  },
  typography: {
    fontFamily: 'Montserrat, Arial, sans-serif', // Set Montserrat globally
    h1: {
      fontFamily: 'Montserrat, Arial, sans-serif', // Use Montserrat for h1
      fontWeight: 700, // Optional: Bold for headings
    },
    h2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 400,
    },
    h5: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 600,
      fontSize: 32,
    },
    h7: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 300,
    },
    body1: {
      fontFamily: 'Montserrat, Arial, sans-serif',
    },
    body2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
    },
  },
});